'use client';
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import React from 'react';
import Typography from '../Typography';

const ErrorListContainer = ({ children }) => <ul css={{ listStyle: 'disc', paddingLeft: 20 }}>{children}</ul>;

const ErrorList = ({ errors = {}, touched = {} }) => {
	if (!Object.keys(errors).length || !Object.keys(touched).length) return null;
	return (
		<div css={{ marginBottom: 60 }}>
			<Typography variant="body2" color="error.dark" className='mb-0'>
				{'Campos incompletos'}
			</Typography>
			<ErrorListContainer>
				<>
					{Object.keys(errors).map((error, i) =>
						errors[error] ? (
							<Typography key={i} variant="body2" component="li" color="error.dark" className='mb-0'>
								{errors[error]}
							</Typography>
						) : null,
					)}
				</>
			</ErrorListContainer>
		</div>
	);
};

export default ErrorList;
